import { authorizeAxios, deauthorizeAxios } from "@/api/axios";
import authApi from "@/api/v1/auth";
import usersApi from "@/api/v1/users";

import router from "@/router/index";

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem("NBP-Auth-Token") || "",
    refreshToken: localStorage.getItem("NBP-Refresh-Token") || "",
    tokenExp: localStorage.getItem("NBP-Token-Expiration") || "",
    user: JSON.parse(localStorage.getItem("NBP-User")) || null,
    destinationPath: "",
    isProcessing: false
  },

  mutations: {
    SET_USER_DATA(state, user) {
      state.user = user;
      localStorage.setItem("NBP-User", JSON.stringify(user));
    },

    SET_TOKEN(state, { token, refreshToken, tokenExp, exp }) {
      state.token = token;
      state.refreshToken = refreshToken;
      state.tokenExp = tokenExp || exp;
      localStorage.setItem("NBP-Auth-Token", token);
      localStorage.setItem("NBP-Refresh-Token", refreshToken);
      localStorage.setItem("NBP-Token-Expiration", tokenExp || exp);
    },

    CLEAR_SESSION_DATA(state) {
      state.token = "";
      state.refreshToken = "";
      state.tokenExp = "";
      state.user = {};
      localStorage.removeItem("NBP-Auth-Token");
      localStorage.removeItem("NBP-Token-Expiration");
      localStorage.removeItem("NBP-Refresh-Token");
      localStorage.removeItem("NBP-User");
    },

    CHANGE_PROCESSING_STATUS(state, status) {
      state.isProcessing = status;
    },

    SET_DESTINATION_PATH(state, path) {
      state.destinationPath = path;
    }
  },

  actions: {
    login({ commit, dispatch, getters, state }, userCredentials) {
      commit("CHANGE_PROCESSING_STATUS", true);

      authApi
        .authenticate(userCredentials)
        .then(resp => {
          commit("SET_TOKEN", resp.data);
          commit("SET_USER_DATA", resp.data.user);
          authorizeAxios(resp.data);
        })
        .then(() => {
          if (state.destinationPath) {
            router.push({ path: state.destinationPath });
            dispatch("changeDestinationPath", "");
          } else {
            let baseRedirectDestination = "required-action-projects";
            if (getters.checkUserPermissions(["user_admin"])) {
              baseRedirectDestination = "admin-settings";
            } else if (getters.checkUserPermissions(["other"])) {
              baseRedirectDestination = "archive-projects";
            }
            router.push({ name: baseRedirectDestination });
          }
        })
        .catch(() => {
          commit("CLEAR_SESSION_DATA");
        })
        .finally(() => {
          commit("CHANGE_PROCESSING_STATUS", false);
        });
    },

    updateUserData({ state, commit }) {
      commit("CHANGE_PROCESSING_STATUS", true);

      usersApi
        .show(state.user.id)
        .then(resp => {
          commit("SET_USER_DATA", {
            ...state.user,
            ...resp.data.user
          });
        })
        .finally(() => {
          commit("CHANGE_PROCESSING_STATUS", false);
        });
    },

    logout({ commit, dispatch }) {
      commit("CLEAR_SESSION_DATA");
      dispatch("changeDestinationPath", "");
      dispatch("dialog/clearDialog", "", { root: true });
      deauthorizeAxios();

      router.push({ name: "login" });
    },

    setPassword({ dispatch }, email) {
      dispatch("changeLoadingStatus", true, { root: true });
      authApi
        .setPassword(email)
        .then(() => {
          dispatch(
            "snackbar/showSnackbar",
            {
              message: ["Hasło zostało zmienione"],
              type: "success"
            },
            { root: true }
          );
        })
        .then(() => {
          router.push({ name: "login" });
        })
        .finally(() => {
          dispatch("changeLoadingStatus", false, { root: true });
        });
    },

    recoverPassword({ dispatch }, params) {
      dispatch("changeLoadingStatus", true, { root: true });
      authApi
        .recoverPassword(params)
        .then(() => {
          dispatch(
            "snackbar/showSnackbar",
            {
              message: ["Na podany adres został wysłany e-mail z linkiem do zmiany hasła"],
              type: "success"
            },
            { root: true }
          );
          dispatch("dialog/clearDialog", {}, { root: true });
        })
        .finally(() => {
          dispatch("changeLoadingStatus", false, { root: true });
        });
    },

    editUserLayout({ state, commit, dispatch }, layoutType) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });

      usersApi
        .update(state.user.id, { layoutType })
        .then(resp => {
          commit("SET_USER_DATA", resp.data);
          dispatch(
            "snackbar/showSnackbar",
            {
              message: ["Układ został zmieniony"],
              type: "success"
            },
            { root: true }
          );
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    changeDestinationPath({ commit }, path) {
      commit("SET_DESTINATION_PATH", path);
    },

    updateUserRoles({ commit, dispatch, state }, roles) {
      dispatch(
        "snackbar/showSnackbar",
        {
          message: ["Pobrano nowe uprawnienia"],
          type: "success"
        },
        { root: true }
      );

      commit("SET_USER_DATA", { ...state.user, roles });
    }
  },

  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },

    checkUserPermissions: state => (availability = []) => {
      const userRoles = state.user.roles?.map(r => r.name);
      return userRoles ? availability.some(r => userRoles.includes(r)) : false;
    },

    checkBelongsToDko: state => {
      return state.user.belongsToDko;
    }
  }
};
